import * as Yup from 'yup';
import generalInformationValidationSchema from "./identification";
import idTypeValidationSchema from "./idType";
import residentialDetailsValidationSchema from "./residentialDetails";

// Create a function to generate validation schemas
const getValidationSchema = (tabId, documentData = []) => {

    switch (tabId) {
        case 'idType':
            return idTypeValidationSchema;
        case 'generalInformation':
            return generalInformationValidationSchema;
        case 'residentialDetails':
            return residentialDetailsValidationSchema;
        // case 'uploadDocuments':
        //     return uploadDocumentsValidationSchema(documentData);
        default:
            return Yup.object(); // Return an empty schema as a fallback
    }
};

export default getValidationSchema;
